/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import APIRequest from "./index";

export function getEnumList(property,callback) {
  return APIRequest('get','/lora/enum/'+property, {}, {}, callback);
}

export function getGatewayList(args,callback) {
  return APIRequest('get','/lora/gateways', args, {}, callback);
}

export function addGateway(mac,name,city,area,address,lat,lng,platform,lorchips,callback) {
  return APIRequest('post','/lora/gateways', {}, {
    mac:mac,
    name:name,
    city:city,
    area:area,
    address:address,
    lat:lat,
    lng:lng,
    platform:platform
  }, callback);
}

export function editGateway(id,dict,callback) {
  return APIRequest('put','/lora/gateways/'+id, {}, dict, callback);
}

export function getGatewayDetail(id,callback) {
  return APIRequest('get','/lora/gateways/'+id, {}, {}, callback);
}

export function delGateway(id,callback) {
  return APIRequest('del','/lora/gateways/'+id, {}, {}, callback);
}

export function gatewayStats(id, from, to, cb) {
  return APIRequest('get', `/lora/gateways/${id}/stats?from=${from}&to=${to}`, {}, {}, cb);
}

export function gatewaySf(id, MILLSN, MILLSL, callback) {
  return APIRequest('get', '/lora/gateways/' + id + '/stats/sf?from=' + MILLSN + '&to=' + MILLSL , {}, {}, callback);
}

export function gatewayFreq(id, MILLSN, MILLSL, callback) {
  return APIRequest('get', '/lora/gateways/' + id + '/stats/freq?from=' + MILLSN + '&to=' + MILLSL , {}, {}, callback);
}

export function gatewayPing(id, callback) {
  return APIRequest('post', '/lora/gateways/' + id + '/ping' , {}, {}, callback);
}

export function gatewayBand(id, callback) {
  return APIRequest('post', '/lora/gateways/' + id + '/readconf' , {}, {}, callback);
}

export function gatewayReset(id, callback) {
  return APIRequest('post', '/lora/gateways/' + id + '/reset' , {}, {}, callback);
}

export function gatewayUpgradeSDK(id, callback) {
  return APIRequest('post', `/lora/gateways/${id}/chkupgrade`, {}, {}, callback);
}

export function gatewayUpgradeSDKCom(id, callback) {
  return APIRequest('post', `/lora/gateways/${id}/upgrade`, {}, {}, callback);
}

export function getGatewayLogRecord(args, GATEWAYMACADDRESS, callback) {
  return APIRequest('get', '/lora/gateways/' + GATEWAYMACADDRESS + '/logs', args, {}, callback);
}
//'get','/devlog/history?src=lora&gateway='+GATEWAYMACADDRESS,args, {}, callback
//'get','/lora/gateways/'+GATEWAYMACADDRESS+'/logs',args, {}, callback
export function getGatewayLog(args,callback) {
  return APIRequest('get','/lora/gateways/logs', args, {}, callback);
}
//GET /v1/lora/gateways/logs?id=GATEWAYID
//return APIRequest('get','/devlog/history?src=lora&type=gateway',args, {}, callback);
export function getGatewaysCount(callback) {
  return APIRequest('get','/lora/gateways/count',{}, {}, callback);
}




// WEBPACK FOOTER //
// ./src/api/lora_gateway.js